import UtilityPageLayout from "../component/layout/UtilityPageLayout";
import styles from "../component/placeholder.module.scss";

export const ServiceRequestHistoryPage = () => {
	return (
		<UtilityPageLayout title="Service Request History">
			<div className={styles.placeholderContainer}>
				<h2 className={styles.title}>Service Request History</h2>
				<p className={styles.description}>
					View all service requests submitted by customers including request status,
					resolution details, and complete request timeline.
				</p>
				<div className={styles.comingSoon}>Coming Soon</div>
			</div>
		</UtilityPageLayout>
	);
};
